import { render, staticRenderFns } from "./EventTabConfig.vue?vue&type=template&id=124aee51&"
import script from "./EventTabConfig.vue?vue&type=script&lang=js&"
export * from "./EventTabConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports